import { Collapse as BlueprintCollapse } from '@blueprintjs/core';
import { ChevronDown, ChevronUp } from '@carbon/icons-react';
import * as React from 'react';
import {
  Icon,
  MenuItem,
  MenuItemProps,
} from 'vet-bones/design-system/components';

import styles from 'src/components/tree/tree.module.scss';

export type TreeNodeProps<T = object> = T & {
  children?: React.ReactNode;
  childNodes?: Array<TreeNodeProps<T>>;
  data?: T;
  hasCaret?: boolean;
  id: string;
  isExpanded?: boolean;
  menuItemProps: Omit<MenuItemProps, 'leftIcon'>;
};

export const TreeNode: React.VFC<TreeNodeProps<any>> = <T extends object>({
  children,
  hasCaret = React.Children.count(children) > 0,
  isExpanded,
  menuItemProps,
}: TreeNodeProps<T>) => {
  let leftElement: JSX.Element | null = null;
  if (hasCaret) {
    leftElement = (
      <Icon
        className={styles.treeNodeChevron}
        IconComponent={isExpanded ? ChevronUp : ChevronDown}
        size="sm"
      />
    );
  }

  return (
    <div className={styles.treeNode}>
      <MenuItem
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...menuItemProps}
        leftElement={leftElement}
        onClick={(evt) => {
          evt.stopPropagation();
          menuItemProps.onClick?.(evt);
        }}
      />
      <BlueprintCollapse isOpen={isExpanded}>{children}</BlueprintCollapse>
    </div>
  );
};
